import React, { ReactNode } from 'react';
import styled from 'styled-components';
import RadioField from 'components/theme/RadioField/RadioField';

interface RadioGroupProps {
  ariaLabel?: string;
  onChange: (value: string) => void;
  options: {
    value: string;
    label: ReactNode;
  }[];
  selectedValue?: string;
}

export const RadioGroup = ({
  ariaLabel,
  onChange,
  options,
  selectedValue,
}: RadioGroupProps) => {
  return (
    <GroupWrapper
      aria-label={ariaLabel ?? 'radio-group'}
      className="radio-buttons__radio-group"
      role="radiogroup"
    >
      {options?.map((option) => (
        <RadioField
          checked={selectedValue === option.value}
          key={`${option.value}-${option.label}`}
          label={option.label}
          onChange={() => onChange(option.value)}
          value={option.value}
        />
      ))}
    </GroupWrapper>
  );
};

const GroupWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;
